/* 三國逗陣打 · 傳說級造型特效（萬聖「百鬼夜行」，docs/HALLOWEEN-SKINS.md）
 * 造型的 legend 欄（meta.ts SKINS）指到這裡的一組畫法：換兵器外型、技能特效、普攻彈道、走路姿勢、腳印、回城。
 * 鐵則：只在畫面層。位置、半徑、時間全照原本的特效（看到哪裡會被打，就是哪裡會被打）；
 * 控制狀態的頭頂圖示不動；遊戲判定（core、server）一律不讀這裡（tests/skinparity.cjs 檢查）。 */
// @ts-nocheck — 畫面層跟 fx.ts 一樣先不補型別
import { SG } from '../core/sg.ts';

const TAU = Math.PI * 2;
const rnd = (a, b) => a + Math.random() * (b - a);
const K = 0.7; // 縱深壓縮（同 SG.K）
const { caps, poly, dot, ink, line } = SG.draw;
const INK = SG.INK;
const now = () => performance.now() / 1000;

// ---------- 色盤（FX.fire 用） ----------
Object.assign(SG.FXPAL, {
  ghost: ['rgba(240,255,220,0.95)', 'rgba(150,240,90,0.85)', 'rgba(30,90,40,0)', '160,240,100', '#c8ff8a'], // 鬼火：青綠
  hell: ['rgba(255,170,150,0.9)', 'rgba(190,10,30,0.9)', 'rgba(20,0,10,0)', '220,30,40', '#ff4a4a'], // 冥火：赤黑
  pumpkin: ['rgba(255,245,200,0.95)', 'rgba(255,140,30,0.9)', 'rgba(90,30,60,0)', '255,150,40', '#ffc06a'], // 南瓜燈：橘
});

const LG = {}; // 造型 legend 名 → 畫法
SG.LEGEND = LG;
SG.LEGEND_W = {}; // 造型 legend 名 → 兵器（rig.ts drawWeapon）
const legendOf = (u) => (u && u.spec && u.spec.legend ? LG[u.spec.legend] || null : null);

// ---------- 共用小零件 ----------
function glow(ctx, x, y, r, col, a) {
  const g = ctx.createRadialGradient(x, y, 0, x, y, r);
  g.addColorStop(0, col); g.addColorStop(1, 'rgba(0,0,0,0)');
  ctx.globalAlpha = a; ctx.fillStyle = g; ctx.beginPath(); ctx.arc(x, y, r, 0, TAU); ctx.fill();
}
// 火舌：從 (x, y) 往上竄
function tongue(ctx, x, y, w, h, col) {
  ctx.fillStyle = col; ctx.beginPath(); ctx.moveTo(x - w, y);
  ctx.quadraticCurveTo(x - w * 0.6, y - h * 0.6, x + w * 0.2, y - h);
  ctx.quadraticCurveTo(x + w * 0.4, y - h * 0.5, x + w, y); ctx.closePath(); ctx.fill();
}
// 紙燈籠（中心 x, y；sc 大小）
function lantern(ctx, x, y, sc, T, lit) {
  ctx.save(); ctx.translate(x, y); ctx.scale(sc, sc);
  if (lit !== false) { ctx.save(); ctx.globalCompositeOperation = 'lighter'; glow(ctx, 0, 0, 22, 'rgba(255,170,60,.75)', 0.7 + 0.2 * Math.sin(T * 9 + x)); ctx.restore(); }
  ctx.globalAlpha = 1;
  ctx.beginPath(); ctx.ellipse(0, 0, 7, 9, 0, 0, TAU); ink(ctx, '#ff8a1e', 1.6);
  ctx.strokeStyle = 'rgba(120,40,10,.6)'; ctx.lineWidth = 1;
  for (const dx of [-3.5, 0, 3.5]) { ctx.beginPath(); ctx.ellipse(0, 0, Math.abs(dx) * 1.6 + 0.5, 9, 0, -Math.PI / 2, Math.PI / 2, dx < 0); ctx.stroke(); }
  ctx.fillStyle = 'rgba(255,240,170,.85)'; ctx.beginPath(); ctx.ellipse(0, 1, 2.6, 4, 0, 0, TAU); ctx.fill();
  poly(ctx, [[-4.5, -9], [4.5, -9], [4, -12], [-4, -12]], '#3a2350', 1.2);
  poly(ctx, [[-4.5, 9], [4.5, 9], [4, 12], [-4, 12]], '#3a2350', 1.2);
  ctx.strokeStyle = '#b6ff5a'; ctx.lineWidth = 1.2; line(ctx, [0, 12], [0, 17]);
  ctx.restore();
}
// 南瓜燈（中心 x, y；r 半徑；face 0~1 燭光亮度）
function pumpkin(ctx, x, y, r, face, rot) {
  ctx.save(); ctx.translate(x, y); if (rot) ctx.rotate(rot);
  ctx.beginPath(); ctx.ellipse(0, 0, r * 1.15, r, 0, 0, TAU); ink(ctx, '#f07a1a', Math.max(1, r * 0.14));
  ctx.strokeStyle = 'rgba(140,50,10,.55)'; ctx.lineWidth = Math.max(0.8, r * 0.1);
  for (const k of [0.45, 0.85]) { ctx.beginPath(); ctx.ellipse(0, 0, r * k, r * 0.98, 0, 0, TAU); ctx.stroke(); }
  caps(ctx, [[[0, -r * 0.9], [r * 0.2, -r * 1.3], Math.max(1.4, r * 0.22), '#3f8a3a']]);
  ctx.fillStyle = `rgba(255,${200 + 40 * face | 0},90,${0.5 + 0.5 * face})`;
  poly(ctx, [[-r * 0.55, -r * 0.2], [-r * 0.25, -r * 0.2], [-r * 0.4, -r * 0.5]], null, 0.01); ctx.fill(); // 左眼
  poly(ctx, [[r * 0.25, -r * 0.2], [r * 0.55, -r * 0.2], [r * 0.4, -r * 0.5]], null, 0.01); ctx.fill(); // 右眼
  ctx.beginPath(); ctx.moveTo(-r * 0.65, r * 0.15);
  for (let i = 0; i <= 6; i++) ctx.lineTo(-r * 0.65 + i * r * 0.217, r * 0.15 + (i % 2 ? r * 0.18 : r * 0.42));
  ctx.lineTo(r * 0.65, r * 0.15); ctx.quadraticCurveTo(0, r * 0.32, -r * 0.65, r * 0.15); ctx.fill();
  ctx.restore();
}
// 骷髏頭（面向 +x）
function skull(ctx, x, y, r, col) {
  ctx.save(); ctx.translate(x, y);
  ctx.beginPath(); ctx.arc(0, -r * 0.1, r, 0, TAU); ink(ctx, col || '#efe4cc', Math.max(1, r * 0.14));
  poly(ctx, [[-r * 0.45, r * 0.6], [r * 0.55, r * 0.6], [r * 0.45, r * 1.05], [-r * 0.35, r * 1.05]], col || '#efe4cc', Math.max(1, r * 0.12));
  ctx.fillStyle = '#2a0a10';
  ctx.beginPath(); ctx.ellipse(r * 0.05, -r * 0.05, r * 0.28, r * 0.32, 0, 0, TAU); ctx.fill();
  ctx.beginPath(); ctx.ellipse(r * 0.6, -r * 0.05, r * 0.24, r * 0.3, 0, 0, TAU); ctx.fill();
  ctx.fillStyle = '#ff3a2a'; ctx.beginPath(); ctx.arc(r * 0.05, -r * 0.02, r * 0.1, 0, TAU); ctx.arc(r * 0.6, -r * 0.02, r * 0.09, 0, TAU); ctx.fill();
  ctx.restore();
}
// 黃符（中心 x, y；w 寬；ch 符上的字）
function talisman(ctx, x, y, w, rot, ch, a) {
  ctx.save(); ctx.translate(x, y); ctx.rotate(rot || 0); ctx.globalAlpha = a == null ? 1 : a;
  const h = w * 2.4;
  poly(ctx, [[-w / 2, -h / 2], [w / 2, -h / 2], [w / 2, h / 2], [-w / 2, h / 2]], '#f2d24a', Math.max(1, w * 0.1));
  ctx.strokeStyle = '#c8281e'; ctx.lineWidth = Math.max(0.8, w * 0.1); ctx.lineCap = 'round';
  if (ch && w >= 14) {
    ctx.fillStyle = '#c8281e'; ctx.font = `900 ${w * 0.62}px "Noto Serif TC", serif`; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
    [...ch].forEach((c, i, all) => ctx.fillText(c, 0, (i - (all.length - 1) / 2) * w * 0.7));
  } else { // 小符：畫幾筆紅色符紋就好
    ctx.beginPath(); ctx.moveTo(0, -h * 0.38); ctx.lineTo(0, h * 0.3); ctx.moveTo(-w * 0.28, -h * 0.18); ctx.lineTo(w * 0.28, -h * 0.18);
    ctx.moveTo(-w * 0.25, h * 0.02); ctx.quadraticCurveTo(w * 0.3, h * 0.08, -w * 0.2, h * 0.22); ctx.stroke();
  }
  ctx.restore();
}
// 蝙蝠（中心 x, y；s 大小；ph 拍翅相位）
function bat(ctx, x, y, s, ph) {
  const fl = Math.sin(ph) * 0.8;
  ctx.save(); ctx.translate(x, y); ctx.scale(s, s); ctx.fillStyle = '#1c1226';
  for (const sd of [-1, 1]) {
    ctx.beginPath(); ctx.moveTo(0, 0);
    ctx.quadraticCurveTo(sd * 6, -6 - fl * 6, sd * 12, -2 - fl * 8);
    ctx.quadraticCurveTo(sd * 9, 0, sd * 10, 3 - fl * 3); ctx.quadraticCurveTo(sd * 6, 1, sd * 5, 4); ctx.quadraticCurveTo(sd * 3, 1, 0, 2); ctx.closePath(); ctx.fill();
  }
  ctx.beginPath(); ctx.arc(0, 0, 2.6, 0, TAU); ctx.fill();
  ctx.fillStyle = '#ff5a3a'; ctx.fillRect(-1.6, -0.8, 1, 1); ctx.fillRect(0.6, -0.8, 1, 1);
  ctx.restore();
}
// 棺材（側面，底部中心在原點；lid 0 闔上 1 打開）
function coffin(ctx, w, h, lid) {
  poly(ctx, [[-w * 0.5, 0], [w * 0.5, 0], [w * 0.62, -h * 0.75], [w * 0.4, -h], [-w * 0.5, -h], [-w * 0.6, -h * 0.75]], '#3a2418', 2);
  ctx.strokeStyle = '#c8a050'; ctx.lineWidth = 1.4; ctx.beginPath(); ctx.moveTo(-w * 0.45, -h * 0.5); ctx.lineTo(w * 0.5, -h * 0.5); ctx.stroke();
  talisman(ctx, 0, -h * 0.5, Math.max(5, w * 0.16), 0, null, 1);
  if (lid > 0) {
    ctx.save(); ctx.translate(-w * 0.5, -h); ctx.rotate(-lid * 1.2);
    poly(ctx, [[0, 0], [w * 0.9, 0], [w * 1.0, -h * 0.12], [0, -h * 0.12]], '#4a2e1e', 1.6);
    ctx.restore();
  }
}

// 自己的粒子（kind 以 lg 開頭）：包住 drawParts，畫完原本的再畫這些
const drawParts0 = SG.drawParts;
SG.drawParts = function (ctx, stage) {
  drawParts0(ctx, stage);
  const T = stage.time;
  for (const p of stage.parts) {
    if (p.t < 0 || p.kind.charCodeAt(0) !== 108 || p.kind[1] !== 'g') continue;
    const k = p.t / p.life, a = k > 0.7 ? (1 - k) / 0.3 : 1;
    ctx.save(); ctx.globalAlpha = a;
    switch (p.kind) {
      case 'lgwisp': // 鬼火：一團往上飄、左右晃的小火
        ctx.globalCompositeOperation = 'lighter';
        glow(ctx, p.x + Math.sin(T * 6 + p.seed) * 3, p.y, p.size * 3, p.col || 'rgba(182,255,90,.9)', a * 0.9);
        ctx.globalAlpha = a; tongue(ctx, p.x + Math.sin(T * 6 + p.seed) * 3, p.y + p.size, p.size * 0.7, p.size * 2.6, p.col || 'rgba(200,255,140,.9)');
        break;
      case 'lgcandy': // 糖果：橘白相間的玉米糖，落地彈一下
        ctx.translate(p.x, p.y); ctx.rotate(p.rot + p.t * 2);
        poly(ctx, [[-3.5, 3], [3.5, 3], [0, -5]], '#ffe8a8', 1);
        ctx.fillStyle = '#ff8a1e'; ctx.fillRect(-2.6, -0.6, 5.2, 2.4);
        break;
      case 'lgpaper': // 飄落的小黃符
        talisman(ctx, p.x + Math.sin(T * 4 + p.seed) * 6, p.y, 5, Math.sin(T * 3 + p.seed) * 0.6, null, a);
        break;
      case 'lgbat':
        bat(ctx, p.x, p.y, p.size, T * 22 + p.seed);
        break;
      case 'lgnote': // 古琴音符（冥火色）
        ctx.fillStyle = '#ff5a4a'; ctx.strokeStyle = '#ff5a4a'; ctx.lineWidth = 1.4;
        ctx.beginPath(); ctx.ellipse(p.x, p.y, 3, 2.2, -0.4, 0, TAU); ctx.fill();
        ctx.beginPath(); ctx.moveTo(p.x + 2.6, p.y - 0.5); ctx.lineTo(p.x + 2.6, p.y - 11); ctx.quadraticCurveTo(p.x + 6, p.y - 8, p.x + 6.5, p.y - 5); ctx.stroke();
        break;
    }
    ctx.restore();
  }
};

// ---------- 新的特效種類（SG.drawFx 會平移到 e.x, e.y 並依面向翻轉） ----------
Object.assign(SG.FX, {
  // 關羽 Q：地上燒著綠火的 X
  lgx(ctx, e, k, T) {
    const a = k < 0.08 ? k / 0.08 : k > 0.6 ? (1 - k) / 0.4 : 1, L = 56;
    ctx.globalCompositeOperation = 'lighter'; ctx.lineCap = 'round';
    for (const s of [1, -1]) {
      ctx.globalAlpha = a * 0.45; ctx.strokeStyle = '#7dff3a'; ctx.lineWidth = 16;
      ctx.beginPath(); ctx.moveTo(-L, -s * L * K * 0.6); ctx.lineTo(L, s * L * K * 0.6); ctx.stroke();
      ctx.globalAlpha = a; ctx.strokeStyle = '#eaffd0'; ctx.lineWidth = 4;
      ctx.beginPath(); ctx.moveTo(-L, -s * L * K * 0.6); ctx.lineTo(L, s * L * K * 0.6); ctx.stroke();
    }
    ctx.globalCompositeOperation = 'source-over';
    for (let i = 0; i < 6; i++) {
      const q = (i % 3) / 2 - 0.5, s = i < 3 ? 1 : -1;
      ctx.save(); ctx.translate(q * 2 * L * 0.8, s * q * 2 * L * K * 0.6 * 0.8); ctx.scale(0.55, 0.55);
      SG.FX.fire(ctx, { pal: 'ghost', small: 1, seed: i * 1.3, s: 1 }, Math.min(0.9, k * 1.2), T);
      ctx.restore();
    }
  },
  // 關羽 W：落地範圍（半徑＝傷害半徑）一圈綠火、圈內浮起燈籠
  lgslam(ctx, e, k, T) {
    const a = k < 0.05 ? k / 0.05 : 1 - k, R = e.r;
    ctx.globalCompositeOperation = 'lighter';
    ctx.globalAlpha = a * 0.25; ctx.fillStyle = '#7dff3a'; ctx.beginPath(); ctx.ellipse(0, 0, R, R * K, 0, 0, TAU); ctx.fill();
    ctx.globalAlpha = a * 0.9; ctx.strokeStyle = '#b6ff5a'; ctx.lineWidth = 3;
    ctx.beginPath(); ctx.ellipse(0, 0, R, R * K, 0, 0, TAU); ctx.stroke();
    ctx.globalCompositeOperation = 'source-over';
    for (const l of e.lan) {
      const q = Math.max(0, k - l.d) / (1 - l.d), y = l.y - q * 90;
      ctx.globalAlpha = Math.min(1, a * 1.6);
      lantern(ctx, l.x, y, 1.3, T, true);
    }
  },
  // 南瓜裂開：落雷打中的地方
  lgpop(ctx, e, k, T) {
    const a = k > 0.6 ? (1 - k) / 0.4 : 1, open = Math.min(1, k * 6);
    ctx.globalAlpha = a;
    ctx.save(); ctx.globalCompositeOperation = 'lighter'; glow(ctx, 0, -14, 40, 'rgba(255,170,60,.9)', a * (1 - open * 0.4)); ctx.restore();
    ctx.globalAlpha = a;
    for (const s of [-1, 1]) { // 兩半往外倒
      ctx.save(); ctx.translate(s * open * 10, -12 + open * 4); ctx.rotate(s * open * 0.6);
      ctx.beginPath(); ctx.ellipse(0, 0, 13, 12, 0, s < 0 ? Math.PI / 2 : -Math.PI / 2, s < 0 ? Math.PI * 1.5 : Math.PI / 2); ctx.closePath(); ink(ctx, '#f07a1a', 1.6);
      ctx.restore();
    }
    for (let i = 0; i < 3; i++) { ctx.save(); ctx.translate((i - 1) * 10, -4); ctx.scale(0.35, 0.35); SG.FX.fire(ctx, { pal: 'pumpkin', small: 1, seed: i * 2.1, s: 1 }, Math.min(0.9, k), T); ctx.restore(); }
  },
  // 南瓜軍師大招：身後浮出的巨大南瓜燈虛影
  lgbigpump(ctx, e, k, T) {
    const a = (k < 0.15 ? k / 0.15 : k > 0.75 ? (1 - k) / 0.25 : 1) * 0.75, rise = Math.min(1, k * 4);
    ctx.globalAlpha = a;
    ctx.save(); ctx.globalCompositeOperation = 'lighter'; glow(ctx, 0, -130 - rise * 20, 120, 'rgba(255,140,40,.8)', a * 0.8); ctx.restore();
    ctx.globalAlpha = a; pumpkin(ctx, 0, -130 - rise * 20, 56, 0.6 + 0.4 * Math.sin(T * 14), 0);
  },
  // 冥府鐵索：火燒連環兩道火柱之間的燃燒鐵鍊（e.dx, e.dy 是到下一道火柱的位移）
  lgchain(ctx, e, k, T) {
    const a = k < 0.1 ? k / 0.1 : k > 0.7 ? (1 - k) / 0.3 : 1, L = Math.hypot(e.dx, e.dy), n = Math.max(2, Math.floor(L / 11)), ang = Math.atan2(e.dy, e.dx);
    ctx.globalAlpha = a;
    for (let i = 0; i <= n; i++) {
      const q = i / n, x = e.dx * q, y = e.dy * q - 26 - Math.sin(q * Math.PI) * 8;
      ctx.save(); ctx.translate(x, y); ctx.rotate(ang + (i % 2 ? Math.PI / 2 : 0));
      ctx.beginPath(); ctx.ellipse(0, 0, 8, 4.4, 0, 0, TAU); ctx.lineWidth = 5.4; ctx.strokeStyle = INK; ctx.stroke(); ctx.lineWidth = 3; ctx.strokeStyle = '#8a8f96'; ctx.stroke();
      ctx.restore();
      if (i % 2 === 0) { ctx.save(); ctx.globalCompositeOperation = 'lighter'; glow(ctx, x, y, 10, 'rgba(255,60,40,.9)', a * (0.6 + 0.4 * Math.sin(T * 12 + i))); ctx.restore(); ctx.globalAlpha = a; }
    }
  },
  // 夜叉面具：反間計打中的人頭上閃出一張面具
  lgmask(ctx, e, k) {
    const a = k > 0.6 ? (1 - k) / 0.4 : 1, s = 1 + (1 - Math.min(1, k * 5)) * 0.6;
    ctx.globalAlpha = a; ctx.translate(0, -112); ctx.scale(s, s);
    ctx.save(); ctx.globalCompositeOperation = 'lighter'; glow(ctx, 0, 0, 36, 'rgba(255,40,40,.8)', a * 0.7); ctx.restore(); ctx.globalAlpha = a;
    yaksha(ctx, 0, 0, 13);
  },
  // 曹操 E：棺材從地裡升起、蓋上沉下（出發）或打開（抵達）
  lgcoffin(ctx, e, k) {
    const up = k < 0.25 ? k / 0.25 : k > 0.7 ? 1 - (k - 0.7) / 0.3 : 1;
    ctx.globalAlpha = Math.min(1, up * 1.5);
    ctx.save(); ctx.beginPath(); ctx.rect(-60, -140, 120, 140); ctx.clip();
    ctx.translate(0, (1 - up) * 70);
    coffin(ctx, 46, 64, e.open ? Math.min(1, Math.max(0, (k - 0.25) / 0.2)) : Math.max(0, 1 - (k - 0.1) / 0.2));
    ctx.restore();
  },
  // 曹操 R：每名敵將頭上落下一張「敕令」大符，時間＝預警時間
  lgfu(ctx, e, k, T) {
    const drop = Math.pow(k, 2.2), y = -260 + drop * 160, a = k < 0.12 ? k / 0.12 : 1;
    ctx.save(); ctx.globalCompositeOperation = 'lighter'; glow(ctx, 0, y, 46, 'rgba(255,220,90,.8)', a * 0.6); ctx.restore();
    talisman(ctx, 0, y, 26, Math.sin(T * 5) * 0.12 * (1 - k), '敕令', a);
  },
  // 符爆開：黃紙碎片四散
  lgfuburst(ctx, e, k) {
    const a = 1 - k;
    ctx.save(); ctx.globalCompositeOperation = 'lighter'; glow(ctx, 0, -60, 70 * (0.5 + k), 'rgba(160,255,190,.9)', a * 0.8); ctx.restore();
    for (let i = 0; i < 10; i++) {
      const ang = (i / 10) * TAU + e.seed, d = 20 + k * 90;
      talisman(ctx, Math.cos(ang) * d, -60 + Math.sin(ang) * d * 0.7 + k * k * 40, 5, ang + k * 6, null, a);
    }
  },
  // 回城：繞著人慢慢升起的一圈小東西（燈籠／南瓜／骷髏火／黃符）
  lgrecall(ctx, e, k, T) {
    const a = k < 0.1 ? k / 0.1 : k > 0.85 ? (1 - k) / 0.15 : 1;
    for (let i = 0; i < 6; i++) {
      const ang = (i / 6) * TAU + T * 1.2, x = Math.cos(ang) * 46, y = Math.sin(ang) * 46 * K - 20 - k * 50 - (i % 2) * 12;
      ctx.globalAlpha = a;
      if (e.item === 'lantern') lantern(ctx, x, y, 1, T, true);
      else if (e.item === 'pumpkin') pumpkin(ctx, x, y, 7, 0.8, 0);
      else if (e.item === 'skull') { ctx.save(); ctx.globalCompositeOperation = 'lighter'; glow(ctx, x, y, 14, 'rgba(255,50,40,.9)', a); ctx.restore(); ctx.globalAlpha = a; skull(ctx, x, y, 5); }
      else talisman(ctx, x, y, 6, Math.sin(T * 3 + i) * 0.4, null, a);
    }
  },
});

// 夜叉面具（中心 x, y；r 大小）
function yaksha(ctx, x, y, r) {
  ctx.save(); ctx.translate(x, y);
  poly(ctx, [[-r * 0.9, -r * 0.4], [-r * 1.2, -r * 1.3], [-r * 0.4, -r * 0.8], [r * 0.4, -r * 0.8], [r * 1.2, -r * 1.3], [r * 0.9, -r * 0.4], [r * 0.8, r * 0.6], [0, r * 1.1], [-r * 0.8, r * 0.6]], '#b8141e', Math.max(1.2, r * 0.12));
  ctx.fillStyle = '#ffe14a';
  for (const s of [-1, 1]) { ctx.beginPath(); ctx.moveTo(s * r * 0.15, -r * 0.2); ctx.lineTo(s * r * 0.7, -r * 0.45); ctx.lineTo(s * r * 0.6, 0); ctx.closePath(); ctx.fill(); }
  ctx.fillStyle = '#fff'; ctx.beginPath(); ctx.moveTo(-r * 0.5, r * 0.45); ctx.lineTo(r * 0.5, r * 0.45); ctx.lineTo(r * 0.3, r * 0.75); ctx.lineTo(0, r * 0.55); ctx.lineTo(-r * 0.3, r * 0.75); ctx.closePath(); ctx.fill();
  ctx.restore();
}

// 綠色的分身虛影（鬼燈武聖 X字斬的陰兵）
function ghostGreen(spec) {
  if (Object.prototype.hasOwnProperty.call(spec, '_lgGhost')) return spec._lgGhost;
  const c = {};
  for (const k in spec.c) c[k] = spec.c[k] ? '#9fe86a' : spec.c[k];
  spec._lgGhost = Object.assign(Object.create(spec), { skin: '#d8ffc0', hair: '#6fbf4a', beardColor: '#6fbf4a', eyeColor: '#ffffff', c });
  return spec._lgGhost;
}

// ---------- 掛鉤：動作事件（rig.ts → SG.spawn）、遊戲特效（view → SG.fxAt） ----------
const spawn0 = SG.spawn;
SG.spawn = function (stage, a, ev, P) {
  const L = a.spec && a.spec.legend && LG[a.spec.legend], h = L && L.spawn && L.spawn[ev.fx];
  if (h && !(stage.o.skip && stage.o.skip[ev.fx]) && h(stage, a, ev, P) === true) return;
  spawn0(stage, a, ev, P);
};
const RECALL = { recall: 1, recallx: 1, recalldone: 1 };
const fxAt0 = SG.fxAt;
SG.fxAt = function (stage, o) {
  const id = o.src != null ? o.src : RECALL[o.k] ? o.id : null;
  const u = id != null && stage.unitOf ? stage.unitOf(id) : null, L = legendOf(u), h = L && L.at && L.at[o.k];
  if (h && h(stage, o, u, fxAt0) === true) return;
  fxAt0(stage, o);
};
// 投射物：普攻（homing）與技能彈。回傳 true 代表畫過了，不用畫原本的
SG.legendProj = function (ctx, p, WS, homing) {
  const L = legendOf(p.owner);
  return !!(L && L.proj && L.proj(ctx, p, WS.time, homing));
};
SG.legendZone = function (ctx, z, WS) { const L = legendOf(z.owner); if (L && L.zone) L.zone(ctx, z, WS.time); };
SG.legendUnit = function (WS, u, dt, a, w) { const L = legendOf(u); if (L && L.unit) L.unit(WS, u, dt, a, w); };
SG.legendOver = function (ctx, u, WS, view) { const L = legendOf(u); if (L && L.over) L.over(ctx, u, WS, view); };
SG.legendPose = function (actor, P, time) { const L = LG[actor.spec.legend]; if (L && L.pose) L.pose(actor, P, time); };
// 敵方單位身上要畫的東西（冰南瓜殼、傀儡線）由施放者的造型決定：每幀從 WS.lgMarks 找
const mark = (WS, m) => { (WS.lgMarks = WS.lgMarks || []).push(Object.assign({ t0: WS.time }, m)); if (WS.lgMarks.length > 40) WS.lgMarks.shift(); };
const P2 = (stage, o) => stage.parts.push(Object.assign({ t: 0, vx: 0, vy: 0, g: 0, seed: Math.random() * 10 }, o));
const recallFx = (item) => (stage, o) => {
  if (o.k === 'recall') stage.fx.push({ type: 'lgrecall', ground: false, x: o.x, y: o.y, f: 1, s: 1, t: 0, life: o.dur || 3, item, recallId: o.id });
  return false; // 原本的「歸」字陣照畫
};
// 腳印／拖尾：走動時每隔一段放一個
function trail(u, a, dt, every, fn) {
  if (!u.alive || !(u.loop === 'run' || u.loop === 'walk')) return;
  a.lgT = (a.lgT || 0) - dt;
  if (a.lgT <= 0) { a.lgT = every; fn(); }
}

// ============ 鬼燈武聖（關羽） ============
SG.LEGEND_W.gui = function (ctx, h) {
  const T = now();
  caps(ctx, [[[-26, 0], [40, 0], 3.4, '#2a1a3a']]);
  poly(ctx, [[-26, -2], [-33, 0], [-26, 2]], '#ff8a1e', 1.6);
  // 刀桿尾端掛一盞紙燈籠，跟著晃
  ctx.save(); ctx.translate(-22, 2); ctx.rotate(Math.sin(T * 3.2) * 0.3);
  ctx.strokeStyle = INK; ctx.lineWidth = 1; line(ctx, [0, 0], [0, 7]);
  lantern(ctx, 0, 15, 0.7, T, true); ctx.restore();
  // 刀身：黑鐵，刃口一道鬼火綠
  ctx.beginPath(); ctx.moveTo(36, -2.5); ctx.lineTo(60, -3); ctx.quadraticCurveTo(70, -4, 73, -11);
  ctx.quadraticCurveTo(73, 6, 58, 11); ctx.quadraticCurveTo(46, 13, 36, 6); ctx.closePath(); ink(ctx, '#2e3836');
  ctx.save(); ctx.globalCompositeOperation = 'lighter';
  ctx.strokeStyle = '#b6ff5a'; ctx.lineWidth = 2.2; ctx.beginPath(); ctx.moveTo(41, 8); ctx.quadraticCurveTo(60, 10, 71, -6); ctx.stroke();
  // 刀背上竄的綠火
  for (let i = 0; i < 5; i++) {
    const x = 40 + i * 7, hgt = 7 + 5 * Math.sin(T * 9 + i * 1.7);
    tongue(ctx, x, -2.5, 3, hgt, 'rgba(150,255,90,.55)');
  }
  glow(ctx, 58, 2, 16, 'rgba(160,255,90,.6)', 0.6 + 0.2 * Math.sin(T * 7));
  ctx.restore();
  dot(ctx, 36, 1.5, 4.6, '#ff8a1e', 1.6);
  caps(ctx, [[[34, -3], [30, -11], 2.4, '#b6ff5a'], [[36, -3], [35, -12], 2.4, '#b6ff5a']]);
};
LG.gui = {
  spawn: {
    // 刀光拖一串鬼火
    swoosh(stage, a) {
      for (let i = 0; i < 5; i++) P2(stage, { kind: 'lgwisp', x: a.x + a.f * rnd(20, 70) * a.s, y: a.y - rnd(30, 90) * a.s, vy: -rnd(20, 50) * a.s, life: rnd(0.5, 0.9), size: rnd(2, 3.5) * a.s });
      return false;
    },
    // X字斬的分身：提燈的綠色陰兵
    ghost(stage, a, ev, P) {
      stage.fx.push({ type: 'ghost', x: a.x, y: a.y, f: a.f, s: a.s, t: 0, life: 0.5, pose: P, spec: ghostGreen(a.spec), col: '#b6ff5a' });
      P2(stage, { kind: 'lgwisp', x: a.x - a.f * 10 * a.s, y: a.y - 60 * a.s, vy: -30, life: 0.6, size: 3 * a.s });
      return true;
    },
  },
  at: {
    // Q 打中：地上留下燃燒的綠 X；W 落地（特效在自己腳下）：傷害範圍一圈綠火＋浮起燈籠
    slam(stage, o, u, orig) {
      const self = Math.abs(o.x - u.x) < 8 && Math.abs(o.y - u.y) < 8;
      if (!self) { stage.fx.push({ type: 'lgx', ground: true, x: o.x, y: o.y, f: 1, s: 1, t: 0, life: 1.3 }); orig(stage, Object.assign({}, o, { col: '#b6ff5a' })); return true; }
      const R = (u.spec.skills[1] && u.spec.skills[1].x && u.spec.skills[1].x.r) || 145, lan = [];
      for (let i = 0; i < 7; i++) { const ang = (i / 7) * TAU + rnd(-0.3, 0.3), d = R * rnd(0.35, 0.85); lan.push({ x: Math.cos(ang) * d, y: Math.sin(ang) * d * K, d: rnd(0, 0.25) }); }
      stage.fx.push({ type: 'lgslam', ground: false, x: o.x, y: o.y, f: 1, s: 1, t: 0, life: 1.4, r: R, lan });
      orig(stage, Object.assign({}, o, { col: '#b6ff5a' }));
      for (let i = 0; i < 14; i++) P2(stage, { kind: 'lgwisp', x: o.x + rnd(-R, R) * 0.8, y: o.y + rnd(-R, R) * K * 0.8, vy: -rnd(30, 70), life: rnd(0.6, 1.2), size: rnd(2.5, 4) });
      return true;
    },
    recall: recallFx('lantern'),
  },
  // 旋風斬：八盞燈籠繞身轉，半徑＝傷害半徑
  over(ctx, u, WS, view) {
    const b = u.alive && view.ultBuff(u);
    if (!b || !b.aoe) return;
    const R = (b.aoe.r || 160) * 0.85, T = WS.time;
    for (let i = 0; i < 8; i++) {
      const ang = T * 4 + (i / 8) * TAU, x = u.x + Math.cos(ang) * R, y = u.y - 40 + Math.sin(ang) * R * K;
      lantern(ctx, x, y, 1.4, T, true);
    }
  },
  unit(WS, u, dt, a) {
    trail(u, a, dt, 0.28, () => P2(WS, { kind: 'lgwisp', x: u.x - u.f * 14 + rnd(-6, 6), y: u.y - rnd(4, 14), vy: -rnd(15, 35), life: rnd(0.6, 1), size: rnd(1.8, 2.6) }));
  },
};

// ============ 南瓜軍師（諸葛亮） ============
SG.LEGEND_W.nangua = function (ctx, h) {
  const T = now();
  caps(ctx, [[[-5, 0], [6, 0], 2.8, '#3a2228']]);
  // 蝙蝠翼扇：翼膜＋扇骨，邊緣三道弧
  ctx.beginPath(); ctx.moveTo(6, 0); ctx.lineTo(27, -13);
  ctx.quadraticCurveTo(25, -6, 30, -5); ctx.quadraticCurveTo(27, 0, 30, 4); ctx.quadraticCurveTo(25, 6, 27, 13);
  ctx.closePath(); ink(ctx, '#2a1a30');
  ctx.strokeStyle = '#8a6a9a'; ctx.lineWidth = 1;
  for (const [x, y] of [[27, -13], [30, -5], [30, 4], [27, 13]]) line(ctx, [7, 0], [x, y]);
  pumpkin(ctx, 6, 0, 3.6, 0.6 + 0.4 * Math.sin(T * 8), 0);
};
LG.nangua = {
  at: {
    // 暴雷雨：橘紫落雷，打中的地方炸開一顆南瓜燈
    thunder(stage, o, u, orig) {
      orig(stage, Object.assign({}, o, { col: '#ffa54a' }));
      stage.fx.push({ type: 'lgpop', ground: false, x: o.x, y: o.y, f: 1, s: 1, t: 0, life: 1 });
      return true;
    },
    // 極凍凝結：原本的冰霜照畫；凍住的人外面多一層冰南瓜殼（legendOver 找 lgMarks）
    fire(stage, o, u, orig) {
      if (o.pal !== 'ice') return false;
      mark(stage, { k: 'icepump', x: o.x, y: o.y, life: 2.4 });
      for (let i = 0; i < 6; i++) P2(stage, { kind: 'lgcandy', x: o.x + rnd(-30, 30), y: o.y - rnd(40, 70), vx: rnd(-60, 60), vy: -rnd(60, 140), g: 500, floor: o.y + rnd(-6, 6), rot: rnd(0, 6), life: rnd(1.2, 1.8) });
      return false;
    },
    // 臥龍光線：身後浮出巨大南瓜燈
    cast(stage, o) {
      if (o.ult) stage.fx.push({ type: 'lgbigpump', ground: false, x: o.x, y: o.y + 1, f: 1, s: 1, t: 0, life: 2.4 });
      return false;
    },
    recall: recallFx('pumpkin'),
  },
  // 普攻：旋轉的迷你南瓜燈；大招光束：拖著長光的南瓜子
  proj(ctx, p, T, homing) {
    if (homing) { pumpkin(ctx, 0, 0, 6.5, 0.8, T * 10); return true; }
    ctx.globalCompositeOperation = 'lighter';
    const lg = ctx.createLinearGradient(-90, 0, 0, 0); lg.addColorStop(0, 'rgba(255,120,30,0)'); lg.addColorStop(1, 'rgba(255,170,60,.85)');
    ctx.fillStyle = lg; ctx.beginPath(); ctx.moveTo(-90, -4); ctx.lineTo(0, -9); ctx.lineTo(8, 0); ctx.lineTo(0, 9); ctx.lineTo(-90, 4); ctx.closePath(); ctx.fill();
    glow(ctx, 0, 0, 22, 'rgba(255,200,90,.9)', 0.9);
    ctx.globalCompositeOperation = 'source-over'; ctx.globalAlpha = 1;
    pumpkin(ctx, 0, 0, 8, 1, T * 6);
    return true;
  },
  // 颶風：風裡捲著蝙蝠，橘色風芯
  zone(ctx, z, T) {
    if (z.look !== 'tornado') return;
    ctx.save(); ctx.globalCompositeOperation = 'lighter'; glow(ctx, z.x, z.y - 80, 46, 'rgba(255,140,40,.6)', 0.55); ctx.restore();
    for (let i = 0; i < 7; i++) {
      const hgt = 20 + i * 24, ang = T * (5 - i * 0.3) + i * 1.9, r = 26 + hgt * 0.45;
      bat(ctx, z.x + Math.cos(ang) * r, z.y - hgt + Math.sin(ang) * r * 0.3, 1.6, T * 20 + i);
    }
  },
  unit(WS, u, dt, a) {
    trail(u, a, dt, 0.9, () => P2(WS, { kind: 'lgcandy', x: u.x - u.f * 10, y: u.y - 30, vx: -u.f * rnd(10, 30), vy: -rnd(40, 80), g: 400, floor: u.y + rnd(-3, 3), rot: rnd(0, 6), life: 2.2 }));
  },
};

// ============ 夜叉公瑾（周瑜） ============
SG.LEGEND_W.yecha = function (ctx, h) {
  const T = now();
  caps(ctx, [[[-7, 0], [1, 0], 3.8, '#2a0a10']]);
  skull(ctx, 3, 0, 3.6);
  // 骨節劍身
  for (let i = 0; i < 5; i++) { ctx.beginPath(); ctx.ellipse(10 + i * 5.6, 0, 3, 2.6, 0, 0, TAU); ink(ctx, '#e8dcc4', 1.3); }
  poly(ctx, [[36, -2.4], [43, 0], [36, 2.4]], '#e8dcc4', 1.4);
  ctx.save(); ctx.globalCompositeOperation = 'lighter';
  for (let i = 0; i < 5; i++) tongue(ctx, 10 + i * 6.5, -2, 2.6, 6 + 4 * Math.sin(T * 10 + i * 2.1), 'rgba(255,50,40,.55)');
  glow(ctx, 28, 0, 14, 'rgba(255,40,30,.55)', 0.5 + 0.2 * Math.sin(T * 6));
  ctx.restore();
};
LG.yecha = {
  at: {
    // 反間計打中：夜叉面具
    slam(stage, o) {
      if (o.col !== '#b07cff') return false;
      stage.fx.push({ type: 'lgmask', ground: false, x: o.x, y: o.y, f: 1, s: 1, t: 0, life: 1.1 });
      return false;
    },
    // 火燒連環：赤黑地獄火柱，柱與柱之間連著燃燒鐵索
    fire(stage, o, u, orig) {
      if (o.pal && o.pal !== 'fire') return false;
      const last = stage.lgLastFire && stage.lgLastFire[u.id];
      if (last && stage.time - last.t < 0.4) stage.fx.push({ type: 'lgchain', ground: false, x: last.x, y: last.y, f: 1, s: 1, t: 0, life: 1.2, dx: o.x - last.x, dy: o.y - last.y });
      (stage.lgLastFire = stage.lgLastFire || {})[u.id] = { x: o.x, y: o.y, t: stage.time };
      orig(stage, Object.assign({}, o, { pal: 'hell' }));
      for (let i = 0; i < 8; i++) stage.parts.push({ kind: 'dust', x: o.x + rnd(-20, 20), y: o.y - rnd(20, 70), vx: rnd(-15, 15), vy: -rnd(30, 60), g: 0, t: -rnd(0, 0.5), life: rnd(0.8, 1.3), size: rnd(7, 12), tint: '#2a0a12' }); // 黑煙
      return true;
    },
    recall: recallFx('skull'),
  },
  // 普攻：小骷髏冥火；赤壁火箭：大骷髏火球；反間計：黑紙紅印的冥府帖
  proj(ctx, p, T, homing) {
    if (homing || p.shape === 'fire') {
      const r = homing ? 6 : 11;
      ctx.globalCompositeOperation = 'lighter';
      for (let i = 0; i < 4; i++) tongue(ctx, -r * 0.6 - i * r * 0.5, 0, r * 0.7, r * (2.4 - i * 0.4), 'rgba(255,40,30,.45)');
      glow(ctx, 0, 0, r * 2.6, 'rgba(255,40,40,.85)', 0.9);
      ctx.globalCompositeOperation = 'source-over'; ctx.globalAlpha = 1;
      skull(ctx, 0, 0, r);
      return true;
    }
    if (p.shape === 'orb') {
      ctx.save(); ctx.globalCompositeOperation = 'lighter'; glow(ctx, 0, 0, 26, 'rgba(255,30,60,.7)', 0.7); ctx.restore(); ctx.globalAlpha = 1;
      ctx.rotate(Math.sin(T * 12) * 0.25);
      poly(ctx, [[-9, -13], [9, -13], [9, 13], [-9, 13]], '#16121a', 1.6);
      ctx.fillStyle = '#c8141e'; ctx.fillRect(-5, -2, 10, 10);
      ctx.fillStyle = '#ffd0c0'; ctx.font = '900 8px "Noto Serif TC", serif'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle'; ctx.fillText('帖', 0, 3);
      return true;
    }
    return false;
  },
  // 倒戈的人：夜叉面具＋紅色傀儡線連到周瑜（線從周瑜手上拉過去）
  over(ctx, u, WS, view) {
    const w = view.w;
    if (u.alive && w.wind && w.wind.on > 0 && Math.random() < 0.06) P2(WS, { kind: 'lgnote', x: u.x + rnd(-24, 24), y: u.y - rnd(60, 100), vy: -25, vx: rnd(-10, 10), life: 1.4 });
    for (const t of w.units) {
      if (!t.alive || t.kind !== 'hero' || t === u) continue;
      const turned = t.mcTeam != null ? t.owner === u : t.mcT > w.t && t.team !== u.team;
      if (!turned) continue;
      const hx = u.x + u.f * 18, hy = u.y - 60, tx = t.x, ty = t.y - 80;
      ctx.save(); ctx.strokeStyle = 'rgba(255,40,50,.8)'; ctx.lineWidth = 1.4;
      for (const d of [-10, 0, 10]) { ctx.beginPath(); ctx.moveTo(hx, hy); ctx.quadraticCurveTo((hx + tx) / 2, Math.min(hy, ty) - 50 + d, tx + d, ty - 10); ctx.stroke(); }
      yaksha(ctx, t.x, t.y - 98, 10);
      ctx.restore();
    }
  },
  unit(WS, u, dt, a) {
    trail(u, a, dt, 0.3, () => P2(WS, { kind: 'lgwisp', col: 'rgba(255,60,40,.9)', x: u.x - u.f * 12 + rnd(-4, 4), y: u.y - 2, vy: -rnd(8, 20), life: rnd(0.6, 0.9), size: rnd(1.6, 2.4) }));
  },
};

// ============ 殭屍孟德（曹操） ============
SG.LEGEND_W.jiangshi = function (ctx, h) {
  const T = now();
  caps(ctx, [[[-7, 0], [1, 0], 3.8, '#5a3a22']]);
  caps(ctx, [[[-8, 0], [-12, 6 + Math.sin(T * 4) * 1.5], 2.2, '#c8281e']]); // 劍穗
  caps(ctx, [[[2, -5.5], [2, 5.5], 3, '#8a5a2e']]);
  poly(ctx, [[4, -2.6], [33, -2.6], [38, 0], [33, 2.6], [4, 2.6]], '#b07a45', 1.8);
  ctx.strokeStyle = 'rgba(90,50,20,.6)'; ctx.lineWidth = 0.8; line(ctx, [7, -0.8], [31, -0.6]); line(ctx, [10, 1], [28, 1.2]);
  // 劍上貼一張黃符，跟著飄
  talisman(ctx, 17, 9, 6, Math.sin(T * 5) * 0.2, null, 1);
};
// 殭屍跳：雙手平舉、併腳跳（只是身體在畫面上彈，腳下影子與位置不動）
const hop = (P, u, run) => {
  const q = Math.abs(Math.sin(u * TAU)), up = (run ? 16 : 11) * q;
  Object.assign(P, { py: P.py - up, lean: 0, bob: 0, head: 0, fl1: 3, fl2: 3, bl1: -3, bl2: -3, fa1: 92, fa2: 92, ba1: 88, ba2: 92, wpn: 96, flow: 6 * q });
};
LG.jiangshi = {
  pose(actor, P) {
    if (actor.cur !== 'walk' && actor.cur !== 'run') return;
    const a = actor.anims[actor.cur];
    hop(P, (actor.t / a.dur) % 1, actor.cur === 'run');
  },
  at: {
    // 黑死爪：黃符飛來貼住、燒成綠光（原本的治療光照畫）
    heal(stage, o) {
      stage.fx.push({ type: 'lgfuburst', ground: false, x: o.x, y: o.y, f: 1, s: 1, t: 0, life: 0.9, seed: Math.random() * 6 });
      return false;
    },
    // 火焰直擊：綠色鬼火
    fire(stage, o, u, orig) {
      if (o.pal && o.pal !== 'fire') return false;
      orig(stage, Object.assign({}, o, { pal: 'ghost' }));
      return true;
    },
    // 傳送：出發點棺材蓋上沉下、抵達點棺材打開
    puff(stage, o, u, orig) {
      const open = Math.abs(o.x - u.x) < 8 && Math.abs(o.y - u.y) < 8;
      stage.fx.push({ type: 'lgcoffin', ground: false, x: o.x, y: o.y + 1, f: 1, s: 1, t: 0, life: 1.1, open });
      orig(stage, o);
      return true;
    },
    // 亂世奸雄：預警圈照畫，頭上多落下一張「敕令」大符（時間＝預警時間）
    warn(stage, o) {
      stage.fx.push({ type: 'lgfu', ground: false, x: o.x, y: o.y, f: 1, s: 1, t: 0, life: o.t || 1 });
      return false;
    },
    thunder(stage, o, u, orig) {
      orig(stage, Object.assign({}, o, { col: '#9fffc8' }));
      stage.fx.push({ type: 'lgfuburst', ground: false, x: o.x, y: o.y, f: 1, s: 1, t: 0, life: 1, seed: Math.random() * 6 });
      for (let i = 0; i < 6; i++) P2(stage, { kind: 'lgbat', x: o.x, y: o.y - 60, vx: rnd(-160, 160), vy: -rnd(40, 160), life: rnd(0.7, 1.1), size: rnd(0.8, 1.2) });
      return true;
    },
    recall: recallFx('talisman'),
  },
  // 普攻：飛出一張黃符
  proj(ctx, p, T, homing) {
    if (!homing) return false;
    talisman(ctx, 0, 0, 7, Math.PI / 2 + Math.sin(T * 14) * 0.2, null, 1);
    return true;
  },
  unit(WS, u, dt, a) {
    // 每跳一下，落地揚一點塵；偶爾掉一張小符
    trail(u, a, dt, u.loop === 'run' ? 0.25 : 0.4, () => {
      for (let i = 0; i < 3; i++) WS.parts.push({ kind: 'dust', x: u.x + rnd(-10, 10), y: u.y + 2, vx: rnd(-30, 30), vy: -rnd(5, 15), g: 10, t: 0, life: rnd(0.4, 0.7), size: rnd(4, 7), tint: '#9fb8a8' });
      if (Math.random() < 0.25) P2(WS, { kind: 'lgpaper', x: u.x - u.f * 10, y: u.y - 70, vy: 30, vx: -u.f * 10, life: 1.6 });
    });
  },
};

// 南瓜軍師凍住的人：冰南瓜殼。畫在被凍的人身上（view 畫冰塊之後呼叫），從標記找是不是南瓜軍師凍的
SG.legendIce = (ctx, u, WS) => {
  const ms = WS.lgMarks;
  if (!ms || !(u.st && u.st.freeze > 0)) return;
  if (!ms.some((m) => m.k === 'icepump' && WS.time - m.t0 < m.life && Math.abs(m.x - u.x) < 220 && Math.abs(m.y - u.y) < 160)) return;
  ctx.save(); ctx.globalAlpha = 0.5; ctx.translate(u.x, u.y - 52); ctx.scale(1, 1.4); pumpkin(ctx, 0, 0, 36, 0.3, 0); ctx.restore();
  ctx.save(); ctx.globalCompositeOperation = 'lighter'; ctx.strokeStyle = 'rgba(180,230,255,.8)'; ctx.lineWidth = 2.5;
  ctx.beginPath(); ctx.ellipse(u.x, u.y - 52, 43, 52, 0, 0, TAU); ctx.stroke(); ctx.restore();
};
